/* ROYALE az: ficha de producto, colores y entrega estimada */
(function(){
  if (window.__azInit) return; window.__azInit = true;

  var COLORES = {
    'negro':'#1C1C1E','black':'#1C1C1E',
    'rosa fucsia':'#E4187F','hot pink':'#E4187F',
    'rosa':'#F0A6C1','pink':'#F0A6C1',
    'rojo':'#C8102E','red':'#C8102E',
    'morado':'#6C2B90','purple':'#6C2B90','deep purple':'#5B2A86',
    'purple lilac':'#B39DDB','lavender':'#C9B6E4',
    'azul cielo':'#7EC8E3','sky blue':'#7EC8E3',
    'turquesa':'#4FC3C7','turquoise breeze':'#4FC3C7','deep sea turquoise':'#1F7A8C',
    'oro rosa':'#DBA79B','rose gold':'#DBA79B',
    'dorado':'#D4AF37','gold':'#D4AF37',
    'yellow':'#F2C230','amarillo':'#F2C230',
    'verde lima':'#A4D65E','lime green':'#A4D65E',
    'naranja':'#F28C28',
    'mármol blanco':'linear-gradient(135deg,#FFFFFF 0%,#F1F1F1 35%,#D4D4D4 55%,#FAFAFA 100%)',
    'white marble':'linear-gradient(135deg,#FFFFFF 0%,#F1F1F1 35%,#D4D4D4 55%,#FAFAFA 100%)',
    'oro rosa brillante':'linear-gradient(135deg,#F6DAD2 0%,#DBA79B 50%,#C08475 100%)',
    'sparkling rose gold':'linear-gradient(135deg,#F6DAD2 0%,#DBA79B 50%,#C08475 100%)',
    'rosa brillante':'linear-gradient(135deg,#FBB3D2 0%,#E4187F 55%,#AF1266 100%)',
    'plata brillante':'linear-gradient(135deg,#FDFDFD 0%,#C9CCD1 50%,#95999E 100%)',
    'morado brillante':'linear-gradient(135deg,#C39BDF 0%,#6C2B90 55%,#45195E 100%)',
    'pink stripes':'repeating-linear-gradient(45deg,#F0A6C1 0 5px,#FFFFFF 5px 10px)',
    'zebra print':'repeating-linear-gradient(45deg,#1C1C1E 0 5px,#FFFFFF 5px 10px)',
    'pink dalmatian':'radial-gradient(#F0A6C1 32%,transparent 33%) 0 0/10px 10px,#FFFFFF',
    'black dalmatian':'radial-gradient(#1C1C1E 32%,transparent 33%) 0 0/10px 10px,#FFFFFF',
    'rose gold & grey':'linear-gradient(90deg,#DBA79B 50%,#9AA0A6 50%)',
    'grey & pink':'linear-gradient(90deg,#9AA0A6 50%,#F0A6C1 50%)',
    'black and rose gold':'linear-gradient(90deg,#1C1C1E 50%,#DBA79B 50%)',
    'hot pink and black':'linear-gradient(90deg,#E4187F 50%,#1C1C1E 50%)',
    'lila':'#B39DDB','lavanda':'#C9B6E4','turquesa profundo':'#1F7A8C',
    'rayas rosas':'repeating-linear-gradient(45deg,#F0A6C1 0 5px,#FFFFFF 5px 10px)',
    'cebra':'repeating-linear-gradient(45deg,#1C1C1E 0 5px,#FFFFFF 5px 10px)',
    'dálmata rosa':'radial-gradient(#F0A6C1 32%,transparent 33%) 0 0/10px 10px,#FFFFFF',
    'dálmata negro':'radial-gradient(#1C1C1E 32%,transparent 33%) 0 0/10px 10px,#FFFFFF',
    'oro rosa y gris':'linear-gradient(90deg,#DBA79B 50%,#9AA0A6 50%)',
    'gris y rosa':'linear-gradient(90deg,#9AA0A6 50%,#F0A6C1 50%)',
    'negro y oro rosa':'linear-gradient(90deg,#1C1C1E 50%,#DBA79B 50%)',
    'rosa fucsia y negro':'linear-gradient(90deg,#E4187F 50%,#1C1C1E 50%)'
  };
  var NOMBRES = {
    'black':'Negro','hot pink':'Rosa fucsia','pink':'Rosa','red':'Rojo','purple':'Morado',
    'deep purple':'Morado intenso','purple lilac':'Lila','lavender':'Lavanda','sky blue':'Azul cielo',
    'turquoise breeze':'Turquesa','deep sea turquoise':'Turquesa profundo','rose gold':'Oro rosa',
    'gold':'Dorado','yellow':'Amarillo','lime green':'Verde lima','white marble':'Mármol blanco',
    'sparkling rose gold':'Oro rosa brillante','pink stripes':'Rayas rosas','zebra print':'Cebra',
    'pink dalmatian':'Dálmata rosa','black dalmatian':'Dálmata negro','rose gold & grey':'Oro rosa y gris',
    'grey & pink':'Gris y rosa','black and rose gold':'Negro y oro rosa','hot pink and black':'Rosa fucsia y negro'
  };
  function clave(v){ return String(v||'').toLowerCase().trim(); }
  function nombre(v){ var k = clave(v); return NOMBRES[k] || v; }
  function pinta(el, valor, img){
    var c = COLORES[clave(valor)];
    if (c){ el.style.background = c; }
    else if (img){ el.style.backgroundImage = 'url(' + img + ')'; el.style.backgroundSize = 'cover'; }
  }
  window.azPintaColor = pinta;
  window.azNombreColor = nombre;

  function dinero(c){
    var v = c / 100;
    var s = (Math.round(v * 100) % 100 === 0)
      ? Math.round(v).toLocaleString('en-US')
      : v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '$' + s;
  }

  var MESES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  function sumaHabiles(d, n){
    var x = new Date(d.getTime()); var c = 0;
    while (c < n){ x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) c++; }
    return x;
  }
  function textoEntrega(){
    var hoy = new Date();
    var a = sumaHabiles(hoy, 1), b = sumaHabiles(hoy, 3);
    if (a.getMonth() === b.getMonth()){
      return 'Llega entre el <b>' + a.getDate() + '</b> y el <b>' + b.getDate() + ' de ' + MESES[b.getMonth()] + '</b>';
    }
    return 'Llega entre el <b>' + a.getDate() + ' de ' + MESES[a.getMonth()] + '</b> y el <b>' + b.getDate() + ' de ' + MESES[b.getMonth()] + '</b>';
  }
  function entregas(){
    var els = document.querySelectorAll('[data-az-eta]');
    for (var i = 0; i < els.length; i++){ els[i].innerHTML = textoEntrega(); }
  }

  function tarjetas(){
    var dots = document.querySelectorAll('[data-az-dot]');
    for (var i = 0; i < dots.length; i++){
      if (dots[i].getAttribute('data-az-done')) continue;
      pinta(dots[i], dots[i].getAttribute('data-az-dot'), dots[i].getAttribute('data-img'));
      dots[i].setAttribute('title', nombre(dots[i].getAttribute('data-az-dot')));
      dots[i].setAttribute('data-az-done', '1');
    }
  }

  function ficha(root){
    if (root.getAttribute('data-az-ready')) return;
    root.setAttribute('data-az-ready', '1');
    var jsonEl = root.querySelector('[data-az-json]');
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [], colorIdx: -1 };
    var variants = data.variants || [];
    var colorIdx = data.colorIdx;

    // galeria
    var track = root.querySelector('[data-az-track]');
    var slides = track ? [].slice.call(track.children) : [];
    var cnt = root.querySelector('[data-az-idx]');
    var thumbs = [].slice.call(root.querySelectorAll('[data-az-th]'));
    var porMedia = {};
    for (var s = 0; s < slides.length; s++){ porMedia[slides[s].getAttribute('data-media')] = s; }
    /* Posición de cada foto dentro del carril (sirve igual si las fotos miden 100 % o si la siguiente se asoma) */
    function pos(i){ return slides[i] ? slides[i].offsetLeft - slides[0].offsetLeft : 0; }
    function actual(){
      if (!track || !slides.length) return 0;
      var x = track.scrollLeft, k = 0, d = Infinity;
      for (var n = 0; n < slides.length; n++){ var dd = Math.abs(pos(n) - x); if (dd < d){ d = dd; k = n; } }
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) k = Math.max(k, slides.length - 1);
      return k;
    }
    function marca(i){
      if (cnt) cnt.textContent = String(i + 1);
      for (var t = 0; t < thumbs.length; t++){ thumbs[t].classList.toggle('is-on', t === i); }
    }
    function ve(i, suave){
      if (!track || !slides.length) return;
      if (i < 0) i = slides.length - 1;
      if (i > slides.length - 1) i = 0;
      track.scrollTo({ left: pos(i), behavior: suave === false ? 'auto' : 'smooth' });
      marca(i);
    }
    if (track){
      var ult = -1;
      track.addEventListener('scroll', function(){ var i = actual(); if (i !== ult){ ult = i; marca(i); } }, { passive: true });
      setInterval(function(){ var i = actual(); if (i !== ult){ ult = i; marca(i); } }, 500);
    }
    var prev = root.querySelector('[data-az-prev]'), next = root.querySelector('[data-az-next]');
    if (prev) prev.addEventListener('click', function(){ ve(actual() - 1); });
    if (next) next.addEventListener('click', function(){ ve(actual() + 1); });
    thumbs.forEach(function(th, k){ th.addEventListener('click', function(){ ve(k); }); });

    // colores
    var sws = [].slice.call(root.querySelectorAll('[data-az-sw]'));
    var nameEl = root.querySelector('[data-az-colorname]');
    sws.forEach(function(b){ pinta(b, b.getAttribute('data-value'), b.getAttribute('data-img')); b.setAttribute('aria-label', nombre(b.getAttribute('data-value'))); });

    var nowEl = root.querySelector('[data-az-now]'), wasEl = root.querySelector('[data-az-was]'),
        saveEl = root.querySelector('[data-az-save]'), msiEl = root.querySelector('[data-az-msi]'),
        btn = root.querySelector('[data-az-add]'), shipN = root.querySelector('[data-az-shipnote]'),
        stockEl = root.querySelector('[data-az-stock]'), qtyIn = root.querySelector('[data-az-qty] input'),
        msiLine = root.querySelector('[data-az-msiline]'), buyB = root.querySelector('[data-az-buy]');
    var stock = data.stock || {};
    var fsBox = root.querySelector('[data-az-fs]'), fsT = root.querySelector('[data-az-fs-t]'), fsBar = fsBox ? fsBox.querySelector('i') : null;
    var fsMin = fsBox ? (parseInt(fsBox.getAttribute('data-min'), 10) || 99900) : 99900, enCarrito = 0, vFs = null;
    function pintaFs(v){
      if (!fsT || !v) return; vFs = v;
      var tot = enCarrito + v.price, falta = fsMin - tot;
      fsT.innerHTML = falta <= 0 ? 'Con este producto tu envío es <b>gratis</b>.' : 'Con este producto te faltan <b>' + dinero(falta) + '</b> para el envío gratis.';
      if (fsBar) fsBar.style.width = Math.max(4, Math.min(100, Math.round(tot * 100 / fsMin))) + '%';
    }
    function cargaCarrito(){ if (!fsT) return; fetch('/cart.js', {credentials: 'same-origin', headers: {accept: 'application/json'}}).then(function(r){ return r.json(); }).then(function(c){ enCarrito = c.total_price || 0; pintaFs(vFs); }).catch(function(){}); }
    document.addEventListener('submit', function(e){ var f = e.target; if (f && f.getAttribute && (f.getAttribute('action') || '').indexOf('/cart/add') > -1) setTimeout(cargaCarrito, 1500); }, true);
    root.addEventListener('click', function(e){
      var m = e.target.closest ? e.target.closest('[data-az-qm],[data-az-qp]') : null;
      if (!m || !qtyIn) return;
      var n = (parseInt(qtyIn.value, 10) || 1) + (m.hasAttribute('data-az-qp') ? 1 : -1);
      qtyIn.value = Math.max(1, Math.min(10, n));
    });
    if (qtyIn) qtyIn.addEventListener('change', function(){ var n = parseInt(qtyIn.value, 10) || 1; qtyIn.value = Math.max(1, Math.min(10, n)); });

    function pintaVariante(v, mover){
      if (!v) return;
      if (nowEl) nowEl.textContent = dinero(v.price);
      var stkP = document.querySelector('[data-az-stk-p]'); if (stkP) stkP.textContent = dinero(v.price);
      var tiene = v.compare_at_price && v.compare_at_price > v.price;
      if (wasEl){ wasEl.textContent = tiene ? dinero(v.compare_at_price) : ''; wasEl.hidden = !tiene; }
      if (saveEl){ saveEl.textContent = tiene ? ('Ahorras ' + dinero(v.compare_at_price - v.price)) : ''; saveEl.hidden = !tiene; }
      if (msiEl) msiEl.textContent = dinero(Math.ceil(v.price / 900) * 100);
      if (msiLine) msiLine.hidden = v.price < 90000;
      if (shipN) shipN.textContent = v.price >= 99900 ? 'Tu envío es gratis.' : 'Envío gratis en compras desde $999.';
      pintaFs(v);
      var ins = root.querySelectorAll('form.az-form input[name="id"]');
      for (var i = 0; i < ins.length; i++){ ins[i].value = v.id; }
      if (btn){ btn.disabled = !v.available; btn.textContent = v.available ? 'Agregar al carrito' : 'Agotado'; }
      if (buyB){ buyB.disabled = !v.available; }
      if (stockEl){
        var sq = stock[String(v.id)];
        if (v.available && typeof sq === 'number' && sq > 0 && sq <= 5){
          stockEl.textContent = (sq === 1 ? 'Queda 1 pieza' : 'Quedan ' + sq + ' piezas') + (colorIdx > -1 ? ' en este color' : '');
          stockEl.hidden = false;
        } else { stockEl.hidden = true; }
      }
      if (colorIdx > -1){
        var val = v.options[colorIdx];
        if (nameEl) nameEl.textContent = nombre(val);
        sws.forEach(function(b){ b.classList.toggle('is-on', b.getAttribute('data-value') === val); b.setAttribute('aria-pressed', b.getAttribute('data-value') === val ? 'true' : 'false'); });
      }
      if (mover && v.featured_media && porMedia[v.featured_media.id] !== undefined){ ve(porMedia[v.featured_media.id]); }
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    }

    var actualV = null;
    for (var q = 0; q < variants.length; q++){ if (String(variants[q].id) === String(data.current)){ actualV = variants[q]; } }
    if (!actualV) actualV = variants[0];

    sws.forEach(function(b){
      b.addEventListener('click', function(){
        var val = b.getAttribute('data-value');
        var elegido = null, respaldo = null;
        for (var i = 0; i < variants.length; i++){
          var v = variants[i];
          if (v.options[colorIdx] !== val) continue;
          if (!respaldo) respaldo = v;
          var igual = true;
          for (var o = 0; o < v.options.length; o++){
            if (o === colorIdx) continue;
            if (actualV && v.options[o] !== actualV.options[o]) igual = false;
          }
          if (igual){ elegido = v; break; }
        }
        actualV = elegido || respaldo || actualV;
        pintaVariante(actualV, true);
      });
    });

    // estado inicial
    // data-az-keepfirst (cepillo alaciador): la galería arranca en la foto de uso, salvo que la liga traiga ?variant=
    var quedaPrimera = root.hasAttribute('data-az-keepfirst') && !/[?&]variant=/.test(window.location.search);
    if (actualV){
      pintaVariante(actualV, false);
      cargaCarrito();
      if (!quedaPrimera && actualV.featured_media && porMedia[actualV.featured_media.id] !== undefined){
        setTimeout(function(){ ve(porMedia[actualV.featured_media.id], false); }, 60);
      }
    }
  }

  // comprar ahora: agrega la cantidad elegida y va directo al pago
  document.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('[data-az-buy]') : null;
    if (!b || b.disabled) return;
    e.preventDefault();
    var root = b.closest('[data-az-product]');
    var f = root ? root.querySelector('form.az-form') : null;
    var idEl = f ? f.querySelector('[name="id"]') : null;
    var qEl = f ? f.querySelector('[name="quantity"]') : null;
    if (!idEl || !idEl.value) return;
    var old = b.textContent;
    b.disabled = true; b.textContent = 'Un momento...';
    fetch('/cart/add.js', {method: 'POST', credentials: 'same-origin', headers: {'content-type': 'application/json', accept: 'application/json'},
      body: JSON.stringify({items: [{id: Number(idEl.value), quantity: Math.max(1, parseInt(qEl && qEl.value, 10) || 1)}]})})
      .then(function(r){ if (!r.ok) throw new Error('add'); window.location.href = '/checkout'; })
      .catch(function(){ b.disabled = false; b.textContent = old; });
  });

  // videos de la descripcion: se reproducen solos al verse, sin sonido
  function videos(){
    var vs = [].slice.call(document.querySelectorAll('[data-az-autovid]'));
    if (!vs.length) return;
    var quieto = false;
    try { quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches || (navigator.connection && navigator.connection.saveData); } catch(e){}
    vs.forEach(function(v){
      if (v.getAttribute('data-az-vok')) return;
      v.setAttribute('data-az-vok', '1');
      var box = v.parentNode, manual = false;
      function play(){ var p = v.play(); if (p && p.catch) p.catch(function(){}); }
      v.addEventListener('playing', function(){ box.classList.add('is-on'); });
      v.addEventListener('pause', function(){ box.classList.remove('is-on'); });
      var tg = box.querySelector('[data-az-vtoggle]');
      function toggle(){ manual = true; if (v.paused){ play(); } else { v.pause(); } }
      if (tg) tg.addEventListener('click', toggle);
      v.addEventListener('click', toggle);
      if (quieto || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function(en){
        en.forEach(function(x){
          if (manual) return;
          if (x.isIntersecting && x.intersectionRatio > 0.45){ play(); } else if (!v.paused){ v.pause(); }
        });
      }, {threshold: [0, 0.45, 0.8]}).observe(v);
    });
  }

  function init(){
    entregas();
    videos();
    tarjetas();
    var ps = document.querySelectorAll('[data-az-product]');
    for (var i = 0; i < ps.length; i++){ ficha(ps[i]); }
  }
  window.azInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
